export const BASE_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3030'
    : 'https://fb.respect-m.ru';
export const API_RESPONSE_STATUS_CODE = {
  SUCCESS: 200,
  CREATED: 201,
  UNAUTHORIZED: 401,
};
